import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const assetsDataManagerDataDictionaryGroupRoute: InvariantJiraRoute = {
	name: 'assets-data-manager-data-dictionary-group',
	path: '/jira/assets/data-manager/object-classes/:objectClassId/settings/data-dictionaries/:dictionaryId',
	exact: true,
};
